import { render } from "./order-details.vue?vue&type=template&id=2dc68707&scoped=true"
import script from "./order-details.vue?vue&type=script&lang=js"
export * from "./order-details.vue?vue&type=script&lang=js"

import "./order-details.vue?vue&type=style&index=0&id=2dc68707&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc68707"]])

export default __exports__